<template>
  <div :class="['alt-form-group',{'form-error': errorMessage}]">
    <label :for="id">{{ label }} <span v-if="required" class="required">*</span></label>
    <div 
      :class="['dropdown-container alt-form-field-group tee-filter-list', { 'chosen': isChosen } , { 'open': showDropdown }]"
     @click="toggleDropdown">
      <span class="selected">{{ selectedOption }}</span>
      <ul v-if="showDropdown" class="dropdown-list filter-list-box">
        <li 
          v-for="option in options" 
          :key="option.label" 
          @click.stop="selectOption(option.label, option.value)" 
          :class="{ 'active': option.label === modelValue }"
        >
          {{ htmlSpecialcharsDecode(option.label) }}
        </li>
      </ul>
    </div>
    <!-- Hidden input, styled to be visually hidden but still functional -->
    <input 
      type="text" 
      :name="id" 
      :value="modelValue" 
      class="hidden-input"
    />
    <label v-if="errorMessage" :for="id" class="error">{{ errorMessage }}</label>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';

interface Option {
  label: string;
  value: string;
}

interface Props {
  modelValue: string;
  label: string;
  placeholder?: string;
  required?: boolean
  options: Option[];
  rules?: Record<string, any>;
  errorMessage?: string | null;
  id?: string;
}

const props = defineProps<Props>();
const emit = defineEmits(['update:modelValue','clearError']);

const showDropdown = ref(false);
const isChosen = ref(false); 
const selectedOption = computed(() => {
  const selected = props.options.find(option => option.value === props.modelValue);
  return selected ? selected.label : props.placeholder || props.options[0]?.label;
});
// const errorMessage = ref(props.errorMessage);
const errorMessage = computed(() => props.errorMessage || '');

const toggleDropdown = () => {
  showDropdown.value = !showDropdown.value;
};

const selectOption = (label: string, value: string) => {
  isChosen.value = true;
  emit('update:modelValue', value); // Emit the selected value
  emit('clearError')
  showDropdown.value = false; // Close the dropdown
};

onMounted(() => {
  if (!props.modelValue && props.options.length > 0 && !props.placeholder) {
    emit('update:modelValue', props.options[0].value);
    isChosen.value=true;
  }
});
</script>

<style scoped>
input.hidden-input{
  position: absolute;
  height: 0;
  top: 10px;
  opacity: 0;
  right: 0;
}
</style>